import branchAr from './ar.json'

const messages = {
  ar: {
    ...branchAr,
  },
}

export default messages
